import React, { Component } from 'react';
import RDP_CONFIG from '../../config';
import { UserService } from '../../services/user';
import './element-quote-4-properties.css';
import {
  RDPDamWidget, ColorPicker, FontPicker
} from '../../components';
import PreferenceRequiredInteraction
  from "../../components/preference-required-interaction/preference-required-interaction";

export default class ElementQuote4Properties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "content": this.props.content,
      "dam_widget_opened": false,
      "dam_active_asset": null,
      "avatar_backup": null
    }

    this.onContentTitleChange = this.onContentTitleChange.bind(this);
    this.onPrimaryColorChange = this.onPrimaryColorChange.bind(this);
    this.onBackgroundColorChange = this.onBackgroundColorChange.bind(this);
    this.onMarginTopChange = this.onMarginTopChange.bind(this);
    this.onMarginBottomChange = this.onMarginBottomChange.bind(this);
  }

  onContentTitleChange(e) {
    var content = this.state.content;
    content.content_title = e.currentTarget.value !== "" ? e.currentTarget.value : content.content_title;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPrimaryColorChange(color) {
    var content = this.state.content;
    content.primary_color = color;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onBackgroundColorChange(color) {
    var content = this.state.content;
    content.background_color = color;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onMarginTopChange(e) {
    var content = this.state.content;
    var px = e.currentTarget.value !== "" ? e.currentTarget.value : content.margin_top;
    content.margin_top = px;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onMarginBottomChange(e) {
    var content = this.state.content;
    var px = e.currentTarget.value !== "" ? e.currentTarget.value : content.margin_bottom;
    content.margin_bottom = px;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onAvatarImageChange() {
    this.setState({
      "dam_active_asset": "avatar",
      "dam_widget_opened": true
    })
  }

  onAssetChange(asset) {
    var content = this.state.content;
    var activeAsset = this.state.dam_active_asset;
    if (activeAsset === "background_image") {
      content.background_image = asset;
    } else if (activeAsset === "avatar") {
      content.avatar = asset;
    }
    this.setState({
      "content": content,
      "dam_widget_opened": false,
      "dam_active_asset": null
    })
  }

  onRDPDamWidgetClose() {
    this.setState({
      "dam_widget_opened": false,
      "dam_active_asset": null
    })
  }

  onRemoveAvatar() {
    var content = this.state.content;
    var avatar_backup = content.avatar;
    content.avatar = null;
    this.setState({
      "content": content,
      "avatar_backup": avatar_backup
    })
  }

  onRestoreAvatar() {
    var content = this.state.content;
    content.avatar = this.state.avatar_backup;
    this.setState({
      "content": content,
    })
  }

  isDefaultAvatar() {
    var content = this.state.content;
    return (content.avatar === this.state.avatar_backup && this.state.avatar_backup !== null) || this.state.avatar_backup === null;
  }

  renderDAMWidget() {
    if (this.state.dam_widget_opened === true) {
      return <RDPDamWidget
        labels={this.props.labels}
        type="image"
        onClose={() => this.onRDPDamWidgetClose()}
        onAssetChange={(asset) => this.onAssetChange(asset)}
      />;
    }
  }

  getBackgroundUrl(image) {
    var accessToken = UserService.getUser().access_token;
    if (image !== "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/background.png") {
      image += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return image;
  }

  getAvatarUrl(image) {
    var accessToken = UserService.getUser().access_token;
    if (image !== "https://pocs.digitalpages.com.br/rdpcomposer/media/head-1/avatar.png") {
      image += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return image;
  }

  onFontChange(font) {
    var content = this.state.content;
    content.font_family = font;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  renderFont() {
    var content = this.state.content;
    var labels = this.props.labels;

    if (content.font_family) {
      return <FontPicker font={content.font_family} onFontChange={(font) => this.onFontChange(font)}/>
    } else {
      return <FontPicker hasFont={false} onFontChange={(font) => this.onFontChange(font)} noFontLabel={labels.elements.common_settings.label_no_has_font}/>
    }
  }

  render() {
    var content = this.state.content;
    var labels = this.props.labels;

    return (<div className="rdp-element-quote-4-properties">
      <ul className="rdp-composer-element-edit-tabs">
        <li className="rdp-composer-element-edit-tabs-item active">{labels.elements.common_settings.label_tab_settings}</li>
      </ul>
      <div className="rdp-composer-element-edit-body">
      <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_quote_4.settings_label_content_title}:</span>
        <input type="text" className="rdp-composer-element-edit-input" onChange={(e) => this.onContentTitleChange(e)} defaultValue={content.content_title}></input>
        
        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_quote_4.settings_label_avatar_image}:</span>
        <div className={["rdp-composer-element-quote-4-avatar", content.avatar === null ? "add-avatar" : ""].join(" ")} onClick={() => this.onAvatarImageChange()}>
          <img src={this.getAvatarUrl(content.avatar)} />
        </div>

        <div className="rdp-composer-element-quote-4-avatar-options">
          <button className="rdp-composer-element-quote-4-avatar-add" type="button" onClick={() => this.onAvatarImageChange()} hidden={content.avatar !== null}>{labels.elements.settings.element_quote_4.settings_button_avatar_add}</button>
          <button className="rdp-composer-element-quote-4-avatar-remove" type="button" onClick={() => this.onRemoveAvatar()} hidden={content.avatar === null}>{labels.elements.settings.element_quote_4.settings_button_avatar_remove}</button>
          <button className="rdp-composer-element-quote-4-avatar-restore-default" type="button" onClick={() => this.onRestoreAvatar()} disabled={this.isDefaultAvatar()}>{labels.elements.settings.element_quote_4.settings_button_avatar_restore}</button>
        </div>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_quote_4.settings_label_background_color}:</span>
        <ColorPicker labels={this.props.labels} color={content.background_color} onChange={this.onBackgroundColorChange} />

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_quote_4.settings_label_primary_color}:</span>
        <ColorPicker labels={this.props.labels} color={content.primary_color} onChange={this.onPrimaryColorChange} />

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_quote_4.settings_label_label_font}:</span>
        {this.renderFont()}

        <PreferenceRequiredInteraction
          title={labels.elements.settings.preference_required_interaction.title}
          label={labels.elements.settings.preference_required_interaction.label}
          labels={labels}
          content={content}
          onContentChange={c => {
            this.setState({ content: c });
            this.props.onContentChange(c);
          }}
        />
      </div>
      {this.renderDAMWidget()}
    </div>);
  }
}
